import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();

  const previewStats = [
    { val:"4", label:"Full Day",  bg:"#D1FAE5", tc:"#059669" },
    { val:"1", label:"Half Day",  bg:"#FEF3C7", tc:"#D97706" },
    { val:"1", label:"Overtime",  bg:"#DBEAFE", tc:"#0369A1" },
  ];

  const previewLabours = [
    { name:"Ramesh Kumar", status:"Full Day", sc:"#059669", sb:"#D1FAE5" },
    { name:"Suresh Yadav", status:"Overtime", sc:"#0369A1", sb:"#DBEAFE" },
    { name:"Mohan Singh",  status:"Half Day", sc:"#D97706", sb:"#FEF3C7" },
  ];

  return (
    <section style={{
      minHeight:"100vh", display:"flex", alignItems:"center",
      justifyContent:"center", padding:"100px 5vw 80px",
      position:"relative", overflow:"hidden",
      background:"radial-gradient(ellipse 80% 60% at 50% -10%, #FEF3C7 0%, transparent 70%), #FAF7F4",
    }}>
      {/* Grid bg */}
      <div style={{
        position:"absolute", inset:0, opacity:.04,
        backgroundImage:"linear-gradient(#92400E 1px,transparent 1px),linear-gradient(90deg,#92400E 1px,transparent 1px)",
        backgroundSize:"48px 48px",
        pointerEvents:"none",
      }} />
      {/* Blobs */}
      <div style={{ position:"absolute", width:"500px", height:"500px", borderRadius:"50%", background:"#FDE68A", filter:"blur(80px)", opacity:.22, top:"-100px", right:"-150px", animation:"float 6s ease-in-out infinite", pointerEvents:"none" }} />
      <div style={{ position:"absolute", width:"300px", height:"300px", borderRadius:"50%", background:"#FED7AA", filter:"blur(80px)", opacity:.22, bottom:"50px", left:"-80px", animation:"float 6s 2s ease-in-out infinite", pointerEvents:"none" }} />

      <div style={{ maxWidth:"720px", textAlign:"center", position:"relative", zIndex:2, width:"100%" }}>

        {/* Badge */}
        <div style={{
          display:"inline-flex", alignItems:"center", gap:"8px",
          padding:"7px 16px", borderRadius:"20px",
          background:"#fff", border:"1.5px solid #FDE68A",
          fontSize:"12px", fontWeight:700, color:"#92400E",
          marginBottom:"28px", boxShadow:"0 2px 12px rgba(180,83,9,.1)",
          animation:"fadeUp .6s ease both",
        }}>
          <span style={{ width:"7px", height:"7px", borderRadius:"50%", background:"#D97706", display:"inline-block", animation:"float 2s ease-in-out infinite" }} />
          Labour Management Made Simple
        </div>

        {/* Title */}
        <h1 style={{
          fontFamily:"'Fraunces',serif",
          fontSize:"clamp(40px,6.5vw,72px)",
          fontWeight:900, lineHeight:1.06,
          letterSpacing:"-1px", color:"#1C1917",
          marginBottom:"22px",
          animation:"fadeUp .7s .1s ease both",
        }}>
          Manage your{" "}
          <span style={{
            background:"linear-gradient(135deg,#B45309,#D97706,#F59E0B)",
            backgroundSize:"200% auto",
            WebkitBackgroundClip:"text",
            WebkitTextFillColor:"transparent",
            backgroundClip:"text",
            animation:"shimmer 3s linear infinite",
          }}>workforce</span>
          {" "}like a pro
        </h1>

        {/* Subtitle */}
        <p style={{
          fontSize:"clamp(15px,1.8vw,18px)", color:"#78716C",
          lineHeight:1.65, fontWeight:500, marginBottom:"36px",
          maxWidth:"540px", marginLeft:"auto", marginRight:"auto",
          animation:"fadeUp .7s .2s ease both",
        }}>
          Craftigo helps carpenters track attendance, manage payments, and generate salary reports for their labourers — all from one clean dashboard.
        </p>

        {/* Buttons */}
        <div style={{ display:"flex", gap:"12px", justifyContent:"center", flexWrap:"wrap", marginBottom:"52px", animation:"fadeUp .7s .3s ease both" }}>
          <button
            onClick={() => navigate("/register")}
            style={{
              padding:"14px 28px", borderRadius:"12px", border:"none",
              background:"linear-gradient(135deg,#92400E,#D97706)",
              fontFamily:"'Plus Jakarta Sans',sans-serif",
              fontSize:"15px", fontWeight:700, color:"#fff",
              cursor:"pointer", display:"flex", alignItems:"center", gap:"8px",
              boxShadow:"0 6px 20px rgba(180,83,9,.35)", transition:"all .2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform="translateY(-2px)"; e.currentTarget.style.boxShadow="0 10px 28px rgba(180,83,9,.45)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 6px 20px rgba(180,83,9,.35)"; }}>
            Start for Free <span>→</span>
          </button>
          <button
            onClick={() => navigate("/login")}
            style={{
              padding:"14px 28px", borderRadius:"12px",
              border:"1.5px solid #E7E5E4", background:"#fff",
              fontFamily:"'Plus Jakarta Sans',sans-serif",
              fontSize:"15px", fontWeight:700, color:"#44403C",
              cursor:"pointer", transition:"all .2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor="#D97706"; e.currentTarget.style.color="#92400E"; e.currentTarget.style.background="#FEF3C7"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor="#E7E5E4"; e.currentTarget.style.color="#44403C"; e.currentTarget.style.background="#fff"; }}>
            Sign In to Dashboard
          </button>
        </div>

        {/* Mini dashboard preview */}
        <div style={{
          background:"#fff", border:"1.5px solid #E7E5E4",
          borderRadius:"20px", padding:"20px",
          boxShadow:"0 20px 60px rgba(0,0,0,.08)",
          animation:"fadeUp .8s .4s ease both",
        }}>
          {/* Card header */}
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", paddingBottom:"14px", borderBottom:"1px solid #F5F5F4", marginBottom:"14px" }}>
            <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
              <div style={{ width:"28px", height:"28px", borderRadius:"8px", background:"linear-gradient(135deg,#92400E,#D97706)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px" }}>🪚</div>
              <span style={{ fontWeight:800, fontSize:"14px", color:"#1C1917" }}>Today's Attendance</span>
            </div>
            <div style={{ display:"flex", gap:"6px" }}>
              {["#FCA5A5","#FDE68A","#A7F3D0"].map(c => <span key={c} style={{ width:"10px", height:"10px", borderRadius:"50%", background:c, display:"inline-block" }} />)}
            </div>
          </div>

          {/* Stats row */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"10px", marginBottom:"14px" }}>
            {previewStats.map(s => (
              <div key={s.label} style={{ padding:"12px", borderRadius:"12px", background:s.bg, textAlign:"center" }}>
                <p style={{ fontSize:"22px", fontWeight:900, color:s.tc, fontFamily:"'Fraunces',serif", marginBottom:"2px" }}>{s.val}</p>
                <p style={{ fontSize:"11px", fontWeight:700, color:s.tc }}>{s.label}</p>
              </div>
            ))}
          </div>

          {/* Labour rows */}
          <div style={{ display:"flex", flexDirection:"column", gap:"7px" }}>
            {previewLabours.map(l => (
              <div key={l.name} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 12px", background:"#FAF7F4", borderRadius:"10px" }}>
                <div style={{ display:"flex", alignItems:"center", gap:"9px" }}>
                  <div style={{ width:"30px", height:"30px", borderRadius:"50%", background:"#F5F5F4", border:"1.5px solid #E7E5E4", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:800, color:"#78716C" }}>
                    {l.name[0]}
                  </div>
                  <span style={{ fontSize:"13px", fontWeight:600, color:"#1C1917" }}>{l.name}</span>
                </div>
                <span style={{ padding:"3px 10px", borderRadius:"20px", fontSize:"11px", fontWeight:700, background:l.sb, color:l.sc }}>{l.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}